var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcPropertiesShow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00009 3.9165C3.5475 3.9165 2.20934 7.77642 2.19709 7.8155L2.13525 7.99984L2.1965 8.18417C2.20934 8.22325 3.5475 12.0832 8.00009 12.0832C12.4527 12.0832 13.7908 8.22325 13.8031 8.18417L13.8649 7.99984L13.8037 7.8155C13.7908 7.77642 12.4527 3.9165 8.00009 3.9165ZM8.00009 10.3332C6.71325 10.3332 5.66675 9.28667 5.66675 7.99984C5.66675 6.713 6.71325 5.6665 8.00009 5.6665C9.28692 5.6665 10.3334 6.713 10.3334 7.99984C10.3334 9.28667 9.28692 10.3332 8.00009 10.3332Z",
    fill: "#383839"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99992 6.8335C7.36759 6.8335 6.83325 7.36783 6.83325 8.00016C6.83325 8.6325 7.36759 9.16683 7.99992 9.16683C8.63225 9.16683 9.16658 8.6325 9.16658 8.00016C9.16658 7.36783 8.63225 6.8335 7.99992 6.8335Z",
    fill: "#383839"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPropertiesShow);
export default __webpack_public_path__ + "static/media/ic_properties_show.df47c3124a707b2b075e68f5fdbd59bf.svg";
export { ForwardRef as ReactComponent };